import { requestDataUtil, sendGAEvent } from '../utils';

export enum AdditionalDataEventEnum {
  additional_user_data_step_2_appearance = 'additional_user_data_step_2_appearance',
  additional_user_data_step_2_first_touched = 'additional_user_data_step_2_first_touched',
  additional_user_data_step_2_next = 'additional_user_data_step_2_next',
  additional_user_data_step_3_appearance = 'additional_user_data_step_3_appearance',
  additional_user_data_step_3_first_touched = 'additional_user_data_step_3_first_touched',
  additional_user_data_step_3_result = 'additional_user_data_step_3_result',
  additional_user_data_form_close = 'additional_user_data_form_close',
}

export interface IAdditionalDataResult {
  status: 'success' | 'failed';
  error_data?: any;
  request_data?: Record<string, any>;
}

/**
 * @description This function uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `additional_user_data_step_2_appearance` and the category is `additional_user_data`.
 */
export const sendAdditionalUserDataStep2AppearanceEvent = () => {
  sendGAEvent(AdditionalDataEventEnum.additional_user_data_step_2_appearance, {
    event_category: 'additional_user_data',
  });
};

/**
 * @description This function uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `additional_user_data_step_2_first_touched` and the category is `additional_user_data`.
 * The event is triggered when the user first interacts with the step 2 of the additional user data form.
 */
export const sendAdditionalUserDataStep2FirstTouchedEvent = () => {
  sendGAEvent(
    AdditionalDataEventEnum.additional_user_data_step_2_first_touched,
    {
      event_category: 'additional_user_data',
    }
  );
};

/**
 * @description This function uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `additional_user_data_step_2_next` and the category is `additional_user_data`.
 * The event is triggered when the user clicks the "Next" button in step 2 of the additional user data form.
 */
export const sendAdditionalUserDataStep2NextEvent = () => {
  sendGAEvent(AdditionalDataEventEnum.additional_user_data_step_2_next, {
    event_category: 'additional_user_data',
  });
};

/**
 * @description This function uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `additional_user_data_step_3_appearance` and the category is `additional_user_data`.
 * The event is triggered when the user interacts with step 3 of the additional user data form.
 */
export const sendAdditionalUserDataStep3AppearanceEvent = () => {
  sendGAEvent(AdditionalDataEventEnum.additional_user_data_step_3_appearance, {
    event_category: 'additional_user_data',
  });
};

/**
 * @description This function uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `additional_user_data_step_3_first_touched` and the category is `additional_user_data`.
 * The event is triggered when the user first interacts with step 3 of the additional user data form.
 */
export const sendAdditionalUserDataStep3FirstTouchedEvent = () => {
  sendGAEvent(
    AdditionalDataEventEnum.additional_user_data_step_3_first_touched,
    {
      event_category: 'additional_user_data',
    }
  );
};

/**
 *
 * @param {IAdditionalDataResult} data - The data object containing registration event details.
 * @description This function sends a Google Analytics event when the registration form is submitted.
 * It uses the `gtag` function to send the event with the specified data.
 * The data object should contain the following properties:
 */
export const sendAdditionalUserDataStep3ResultEvent = (
  data: IAdditionalDataResult
) => {
  try {
    sendGAEvent(AdditionalDataEventEnum.additional_user_data_step_3_result, {
      event_category: 'additional_user_data',
      ...data,
      request_data:
        data.request_data &&
        JSON.stringify(
          requestDataUtil(data.request_data, data.error_data) || ''
        ),
      error_data: data.error_data && JSON.stringify(data.error_data),
    });
    return;
  } catch (e) {
    console.error('Error sending additional user data step 3 result event:', e);
    return;
  }
};

/**
 * @description This function uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `additional_user_data_form_close` and the category is `additional_user_data`.
 * The event is triggered when the user closes the additional user data form.
 */
export const sendAdditionalUserDataFormCloseEvent = () => {
  sendGAEvent(AdditionalDataEventEnum.additional_user_data_form_close, {
    event_category: 'additional_user_data',
  });
};
